module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "repeater-form"
  }, [_c('div', {
    staticClass: "panel__block"
  }, [_c('h2', [_vm._v(_vm._s(_vm.setFormTitle))])]), _vm._v(" "), _vm._l((_vm.getData), function(item, index) {
    return _c('div', {
      staticClass: "panel__block repeater-form__row"
    }, [_vm._l((item), function(field, findex) {
      return _c('div', {
        class: _vm.setCellWidth(findex)
      }, [(_vm.isText(field.type)) ? _c('TextInput', {
        attrs: {
          "context": "repeater",
          "type": field.type,
          "value": field.value,
          "row": index,
          "k": field.field,
          "index": findex,
          "label": _vm.getProtoVar(findex, 'name'),
          "id": _vm.getProtoVar(findex, 'key') + index,
          "setting": _vm.isSetting()
        }
      }, [_vm._v(_vm._s(field) + "\n  \t\t    ")]) : _vm._e(), (_vm.isDropdown(field.type)) ? _c('Dropdown', {
        attrs: {
          "context": "repeater",
          "proto": _vm.getProto(findex),
          "value": field.value,
          "row": index,
          "k": field.field,
          "index": findex,
          "label": _vm.getProtoVar(findex, 'name'),
          "id": _vm.getProtoVar(findex, 'key') + index,
          "order": _vm.getProtoVar(findex, 'order')
        }
      }) : _vm._e()], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "repeater-form__cell repeater-form__cell--remove"
    }, [_c('button', {
      staticClass: "remove",
      attrs: {
        "type": "button",
        "data-row": index
      },
      on: {
        "click": _vm.removeRow
      }
    }, [_vm._v("-")])])], 2)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05ff41a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RepeaterForm.vue
// module id = 310
// module chunks = 0